import { Injectable } from '@angular/core';
import { ParrainageDao } from '@app/dao/parrainage/parrainage.dao';
import { BehaviorSubject, Observable, Subject, throwError, catchError, map, switchMap, take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ParrainageService {
  parrainages: BehaviorSubject<any> = new BehaviorSubject([{}, {}]);
  loading: Subject<any> = new Subject();
  constructor(private parrainageDao: ParrainageDao) {}

  getParrainages() {
    this.loading.next(true);
    return this.parrainageDao.getParrainages().pipe(
      tap(parrainages => {
        this.loading.next(false);
        this.parrainages.next(parrainages);
      }),
    );
  }

  deleteParrainage(index: number) {
    this.loading.next(true);
    return this.parrainages.pipe(
      take(1),
      map(parrainage => parrainage.filter((p, i) => i !== index)),
      tap(parrainages => {
        this.parrainages.next(parrainages);
        this.loading.next(false);
      }),
    );
  }

  sendParrainage(form: any): Observable<any> {
    this.loading.next(true);
    return this.parrainageDao.saveParrainage(form).pipe(
      switchMap(() => this.parrainageDao.getParrainages()),
      tap(() => this.loading.next(false)),
      catchError(error => {
        this.loading.next(false);
        return throwError(error);
      }),
    );
  }

  searchSponsors(email: string): Observable<any> {
    return this.parrainageDao.searchSponsors(email);
  }
}
